import { render, staticRenderFns } from "./documents-list-new.vue?vue&type=template&id=13348b44&scoped=true&"
import script from "./documents-list-new.vue?vue&type=script&lang=js&"
export * from "./documents-list-new.vue?vue&type=script&lang=js&"
import style0 from "@/assets/table-styling.scss?vue&type=style&index=0&id=13348b44&scoped=true&lang=scss&"
import style1 from "@/assets/dot-streaching-loader.scss?vue&type=style&index=1&id=13348b44&scoped=true&lang=scss&"
import style2 from "./documents-list-new.vue?vue&type=style&index=2&id=13348b44&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13348b44",
  null
  
)

component.options.__file = "documents-list-new.vue"
export default component.exports